import $ from 'jquery';
// Who We Are - Tabs change
jQuery(document).ready(function($) {
	function slickRestart() {
		$('.js--team-slider').slick('destroy');
		$('.js--team-slider').slick('init');
		$('.js--team-slider').slick('resize');
	}
	if($('#team-tabs').length) {
		$('#team-tabs').on('change.zf.tabs', function() {
			slickRestart();
		});
		$(window).on('resize orientationchange', function() {
			slickRestart();
		});
	}
}(jQuery));
